// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-onboarding-report-locations-widget-table {
  height: 100%;
  display: block;
  overflow: hidden;
  padding: 10px 8px 10px 16px;
}`, "",{"version":3,"sources":["webpack://./Source/app/fi-onboarding/fi-onboarding-report/fi-onboarding-report-details/locations-widget/details-table/fi-onboarding-report-locations-widget-table.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,2BAAA;AACJ","sourcesContent":[".fi-onboarding-report-locations-widget-table {\r\n    height: 100%;\r\n    display: block;\r\n    overflow: hidden;\r\n    padding: 10px 8px 10px 16px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
